import Header from "./Header";
import Guru from "./Guru";
import Footer from "./Footer";
import axios from "axios";
import _ from "lodash";
import { useEffect, useState } from "react";
import * as localforage from "localforage";
import translatedHeading from "../utils/util";
import "../styles/App.css";


const Gurus = () => {
  const [gurus, setGurus] = useState([]);
  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      let initialGurus = [];
      try {
        const cachedGurus = await localforage.getItem("gurus");
        if (isMounted && cachedGurus && Array.isArray(cachedGurus)) {
          initialGurus = cachedGurus;
          setGurus(cachedGurus);
        }
      } catch (error) {
        console.error("Error reading from localforage:", error);
      }

      try {
        const response = await axios.get(
          "https://brahmavidyalayaashram.in/server/api.php?endpoint=/gurus"
        );

        if (
          isMounted &&
          response &&
          response.data &&
          Array.isArray(response.data)
        ) {
          if (!_.isEqual(initialGurus, response.data)) {
            setGurus(response.data);
            await localforage.setItem("gurus", response.data);
          }
        }
      } catch (error) {
        console.log("API fetch error:", error);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <Header />
      <div className="page-header">{translatedHeading("Our Lineage")}</div>
      {gurus.length === 0 && <div className="loader"></div>}
      <div className="gurus">
        {gurus &&
          gurus.map((guru) => {
            return <Guru key={guru.name} data={guru} />;
          })}
      </div>
      <Footer />
    </>
  );
};
export default Gurus;
